import "bootstrap/dist/css/bootstrap.min.css";
import Caurosel from "./Caurosel";
import HeroBanner from "./HeroBanner";
import OneScreenPartner from "./OneScreenPartner";
import CategorySection from "./CategorySection";
import BrandSlider from "./BrandSlider";
import SignGraphicsBanner from "./SignGraphicsBanner";
import WhyChoose from "./WhyChoose";
import IndustriesSection from "./IndustriesSection";
import FeaturedProductsSection from "./FeaturedProductsSection";
import { useHomeContent } from "../hooks/useHomeContent";
import Seo from "../components/Seo";
import { PAGE_SEO } from "../constants/seo";
import { localBusinessSchema, webSiteSchema } from "../utils/seoSchema";
import { HomePageSkeleton } from "../components/Skeleton";

function Home() {
  const { content, loading } = useHomeContent();
  const homeSeo = PAGE_SEO.home;

  if (loading) {
    return (
      <>
        <Seo {...homeSeo} jsonLd={[localBusinessSchema(), webSiteSchema()]} />
        <HomePageSkeleton />
      </>
    );
  }

  return (
    <div>
      <Seo {...homeSeo} jsonLd={[localBusinessSchema(), webSiteSchema()]} />
      <HeroBanner data={content.hero} />
      <CategorySection data={content.shopCategories} />
      <FeaturedProductsSection data={content.featuredProducts} />
      <OneScreenPartner />
      <Caurosel data={content.carousel} />
      <WhyChoose />
      <SignGraphicsBanner />
      <IndustriesSection data={content.industries} />
      <BrandSlider data={content.brandPartners} />
    </div>
  );
}

export default Home;
